import React from "react";
import "./styles.scss";

const ProgressBar = ({ width = 0,progressCountClassName="" }) => {
  return (
    <div className="progress-bar-section position-relative">
      <span className={progressCountClassName} style={{ marginLeft: `calc(${width}% - 14px)` }}>{width}%</span>
      <div className="progressBarWrapper">
        <div className="progress" style={{ width: `${width}%` }} />
      </div>
    </div>
  );
};
export default ProgressBar;
